import { Reveal } from "./Reveal";
import { Instagram, Facebook, Linkedin, Twitter, Youtube, MessageCircle, Heart } from "lucide-react";

const IG = "https://instagram.com/the.dorado9";

const GRAD_PURPLE = "linear-gradient(150deg, #7d67e8 0%, #4c34c0 100%)";
const GRAD_MINT = "linear-gradient(150deg, #2dffc6 0%, #0bb98d 100%)";

// Instagram-style photo tiles
const P = {
  phone: "https://www.instagram.com/reel/DZsZnPWzSaI/",
  team: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&q=60&auto=format&fit=crop",
  shoot: "https://images.unsplash.com/photo-1611746872915-64382b5c76da?w=600&q=60&auto=format&fit=crop",
  board: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=60&auto=format&fit=crop",
  collab: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&q=60&auto=format&fit=crop",
};

function PhotoTile({ src, height, cap }) {
  return (
    <a href={IG} target="_blank" rel="noreferrer" data-testid="social-wall-post"
       className={`group relative block overflow-hidden rounded-2xl border border-white/10 ${height}`}>
      <img src={src} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition-opacity" />
      <div className="absolute top-3 left-3 flex items-center gap-1.5 text-white/90 text-[11px] font-semibold tracking-wide">
        <Instagram size={12} /> @the.dorado9
      </div>
      <Heart size={15} className="absolute top-3 right-3 text-white/80 group-hover:text-brand-mint transition-colors" />
      {cap && <p className="absolute bottom-3 left-3 right-3 text-white text-[13px] leading-snug font-medium">{cap}</p>}
    </a>
  );
}

function SocialTile({ name, href, Icon, height, grad, dark }) {
  return (
    <a href={href} target="_blank" rel="noreferrer"
       data-testid={`social-wall-${name.toLowerCase().split(" ")[0]}`}
       className={`group relative flex flex-col justify-between rounded-2xl p-5 overflow-hidden transition-transform duration-500 hover:-translate-y-1 ${height}`}
       style={{ background: grad }}>
      <span className="absolute inset-0 bg-white/0 group-hover:bg-white/10 transition-colors duration-500" />
      <Icon size={26} strokeWidth={1.9} className={`relative z-10 ${dark ? "text-[#0f2e24]" : "text-white"}`} />
      <div className="relative z-10">
        <p className={`font-display text-lg lg:text-xl uppercase tracking-tight leading-none ${dark ? "text-[#0f2e24]" : "text-white"}`}>{name}</p>
        <p className={`text-[10px] uppercase tracking-[0.22em] mt-1.5 ${dark ? "text-[#0f2e24]/70" : "text-white/70"}`}>Follow us</p>
      </div>
    </a>
  );
}
function InstagramEmbedTile({ image, url, height = "h-[300px]" }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={`
        group
        relative
        block
        overflow-hidden
        rounded-2xl
        border border-white/10
        ${height}
      `}
    >
      <img
        src={image}
        alt=""
        loading="lazy"
        className="
          w-full h-full
          object-cover
          transition-transform
          duration-700
          group-hover:scale-105
        "
      />

      <div className="
        absolute inset-0
        bg-gradient-to-t
        from-black/60
        via-transparent
        to-black/10
      " />

      <div className="
        absolute
        top-4 left-4
        flex items-center gap-2
        text-white text-xs
      ">
        <Instagram size={15} />
        @the.dorado9
      </div>

      <div className="
        absolute
        bottom-4 left-4
        text-xs
        uppercase
        tracking-[0.18em]
        text-white/80
      ">
        View on Instagram →
      </div>
    </a>
  );
}
export default function SocialWall() {
  return (
    <section className="relative bg-brand-bg py-16 lg:py-24 px-6 lg:px-12 border-t border-[color:var(--border)] overflow-hidden" data-testid="social-wall-section">
      <div className="absolute -top-32 left-1/3 w-[45vw] h-[35vw] rounded-full pointer-events-none"
           style={{ background: "radial-gradient(circle, rgba(102,76,221,0.18), transparent 60%)" }} />

      <div className="max-w-[1400px] mx-auto relative">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-12 lg:mb-16">
            <p className="eyebrow mb-5 flex items-center justify-center gap-3">
              <span className="w-8 h-px bg-brand-purple" /> The Social Wall
            </p>
            <h2 className="font-display text-3xl lg:text-5xl uppercase tracking-tighter leading-[0.95]">
              Come say <span className="font-serif-accent text-brand-purple lowercase">hi.</span>
            </h2>
            <p className="mt-5 text-zinc-400 text-sm lg:text-base">Fresh from the feed — and every place you'll find us.</p>
          </div>
        </Reveal>

        {/* Asymmetric staggered band — columns offset for the "peeking" look. Scrolls on mobile. */}
        <Reveal delay={0.1}>
          <div data-lenis-prevent className="flex gap-4 lg:gap-5 overflow-x-auto lg:overflow-visible lg:justify-center pb-4 lg:pb-0 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
            {/* C1 — edge photo, dips down */}
            <div className="flex flex-col gap-4 shrink-0 w-[180px] lg:w-[200px] mt-8 lg:mt-10">
              <InstagramEmbedTile
  image="https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/Screenshot-2026-08-12-at-11.38.32.png"
  url="https://www.instagram.com/reel/DZsZnPWzSaI/"
  height="h-[320px]"
/>
            </div>

            {/* C2 — photo + Facebook (purple) */}
            <div className="flex flex-col gap-4 shrink-0 w-[180px] lg:w-[200px] mt-0">
              <InstagramEmbedTile
              image="https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/Screenshot-2026-08-12-at-11.46.50.png"
  url="https://www.instagram.com/p/DQO-Tb7k801/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
  height="h-[200px]"
/>
              <SocialTile name="Facebook" href="https://facebook.com/dorado9" Icon={Facebook} height="h-[190px]" grad={GRAD_PURPLE} />
            </div>

            {/* C3 — WhatsApp (mint) peeks high */}
            <div className="flex flex-col gap-4 shrink-0 w-[180px] lg:w-[200px] mt-16 lg:mt-20">
              <SocialTile name="WhatsApp" href="https://wa.me/919876543210" Icon={MessageCircle} height="h-[165px]" grad={GRAD_MINT} dark />
              <InstagramEmbedTile
              image="https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/Screenshot-2026-08-12-at-11.55.23.png"
  url="https://www.instagram.com/reel/DPjM5YcExt8/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
  height="h-[200px]"
/>
            </div>

            {/* C4 — photo + YouTube (purple) */}
            <div className="flex flex-col gap-4 shrink-0 w-[180px] lg:w-[200px] mt-3 lg:mt-4">
             <InstagramEmbedTile
              image="https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/Screenshot-2026-08-12-at-11.48.23.png"
  url="https://www.instagram.com/p/DZuGGzETI2u/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
  height="h-[180px]"
/>
              <SocialTile name="YouTube" href="https://youtube.com/@the.dorado9" Icon={Youtube} height="h-[175px]" grad={GRAD_PURPLE} />
            </div>

            {/* C5 — LinkedIn (mint) peeks low */}
            <div className="flex flex-col gap-4 shrink-0 w-[180px] lg:w-[200px] mt-20 lg:mt-24">
              <SocialTile name="LinkedIn" href="https://linkedin.com/company/dorado9" Icon={Linkedin} height="h-[195px]" grad={GRAD_MINT} dark />
            </div>

            {/* C6 — Twitter (purple) + edge photo */}
            <div className="flex flex-col gap-4 shrink-0 w-[180px] lg:w-[200px] mt-2">
              <SocialTile name="Twitter / X" href="https://twitter.com/the_dorado9" Icon={Twitter} height="h-[160px]" grad={GRAD_PURPLE} />
              <InstagramEmbedTile
              image="https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/Screenshot-2026-08-12-at-11.51.16.png"
  url="https://www.instagram.com/p/DWa3cbQk9QX/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
  height="h-[180px]"
/>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
